<unity-page-container contentHeader="Agreements" [isLoading]="false">
  <ng-container notifications />
  <ng-container page-return />

  <ng-container actions>
    <unity-action-shared [action]="createAgreementAction" />
  </ng-container>

  @let agreements = $agreements()?.data ?? [];
  <unity-list-agreement-shared
    [agreements]="agreements"
    [showAgencyName]="$showAgencyName()"
    [isLoading]="$isLoading()"
    [valueStates]="$valueStates()"
    [switchStates]="$switchStates()"
    [count]="$count()"
    [total]="$total()"
    (pageChangeEvent)="handlePageEvent($event)"
    (switchStateEvent)="handleSwitchStateEvent($event)"
    (filterMasterEvent)="handleMasterEvent($event)"
    (filterClearEvent)="handleClearEvent()"
    (filterItemToggleEvent)="handleItemToggleEvent($event)" />
</unity-page-container>
